"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuGroupHeader", {
    enumerable: true,
    get: function() {
        return MenuGroupHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuGroupHeader = require("./useMenuGroupHeader");
const _useMenuGroupHeaderStylesstyles = require("./useMenuGroupHeaderStyles.styles");
const _renderMenuGroupHeader = require("./renderMenuGroupHeader");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuGroupHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuGroupHeader.useMenuGroupHeader_unstable)(props, ref);
    (0, _useMenuGroupHeaderStylesstyles.useMenuGroupHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuGroupHeaderStyles_unstable')(state);
    return (0, _renderMenuGroupHeader.renderMenuGroupHeader_unstable)(state);
});
MenuGroupHeader.displayName = 'MenuGroupHeader';
